import { useEffect, useState } from "react";
import styled from "styled-components";
import { RecordFilesManager } from "./RecordFilesManager";
import { UploadFiles } from "./UploadFiles";
import { FilesDrawer } from "./FilesDrawer";

export const FILE_COMPONENT_ID = {
  shipment: "consignmentDetailFile",
  purchase: "purchaseDetailFile",
  transfer: "transferDetailFile",
  sales: "salesOrderDetailFile",
};

function DrawerRecordTitle({ number, name }) {
  const trimmedName = name?.trim();
  const showName = Boolean(trimmedName) && trimmedName !== number?.trim();

  return (
    <DrawerRecordTitleWrap title={showName ? `${number} (${trimmedName})` : number}>
      {number ? <strong>{number}</strong> : null}
      {showName ? <span> ({trimmedName})</span> : null}
    </DrawerRecordTitleWrap>
  );
}

export function FilesDrawerShell({
  isOpen,
  onClose,
  orderId,
  orderName,
  recordDisplayName,
  orderType,
  getConsignmentByRule,
}) {
  const [liveFileCount, setLiveFileCount] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setLiveFileCount(null);
    }
  }, [isOpen, orderId]);

  if (!isOpen || !orderId) return null;

  const supplementary =
    liveFileCount != null ? (
      <FileCountBadge>
        Files ({liveFileCount})
      </FileCountBadge>
    ) : null;

  const drawerTitle = <DrawerRecordTitle number={orderName} name={recordDisplayName} />;

  if (orderType === "shipment" || orderType === "purchase" || orderType === "sales") {
    return (
      <FilesDrawer isOpen title={drawerTitle} supplementary={supplementary} onClose={onClose}>
        <RecordFilesManager
          orderId={orderId}
          orderName={orderName}
          orderType={orderType}
          onFileCountChange={setLiveFileCount}
        />
      </FilesDrawer>
    );
  }

  return (
    <UploadFiles
      id={orderId}
      recordName={orderName}
      closeUploadFiles={onClose}
      getFiles={getConsignmentByRule}
      componentId={FILE_COMPONENT_ID[orderType] || FILE_COMPONENT_ID.shipment}
    />
  );
}

const DrawerRecordTitleWrap = styled.div`
  color: #10244d;
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  strong {
    font-weight: 600;
  }

  span {
    color: #4a4a68;
    font-weight: 500;
  }
`;

const FileCountBadge = styled.span`
  color: var(--DARK-BLUE, #1249bf);
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
`;
